var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVuesaxOutlineAirdrop(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "{props.color}",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.91 12.88c-.73-.73-1.02-1.78-.78-2.81a2.91 2.91 0 0 1 2.14-2.14c1.02-.25 2.07.04 2.81.78.74.74 1.02 1.78.78 2.81a2.91 2.91 0 0 1-2.14 2.14c-.24.05-.48.08-.72.08-.78 0-1.52-.3-2.09-.86zm1.72-3.49c-.5.12-.91.53-1.03 1.03-.13.52.01 1.03.38 1.39.37.37.87.5 1.4.38.5-.12.91-.53 1.03-1.03.13-.52-.01-1.03-.38-1.39a1.437 1.437 0 0 0-1.4-.38z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.51 17.77a9.545 9.545 0 0 1-3.05-6.98c0-5.26 4.28-9.54 9.54-9.54 5.26 0 9.54 4.28 9.54 9.54 0 2.66-1.07 5.12-3.01 6.95-.3.28-.78.27-1.06-.03-.28-.3-.27-.78.03-1.06a7.938 7.938 0 0 0 2.54-5.85c0-4.43-3.61-8.04-8.04-8.04S3.96 6.37 3.96 10.8c0 2.26.91 4.34 2.57 5.88.3.28.32.76.04 1.06a.763.763 0 0 1-1.06.03z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.49 15.1a.746.746 0 0 1-.03-1.06c.83-.88 1.29-2.04 1.29-3.24 0-2.62-2.13-4.74-4.74-4.74a4.75 4.75 0 0 0-4.74 4.74c0 1.21.46 2.36 1.29 3.24.28.3.27.78-.03 1.06-.3.28-.78.27-1.06-.03a6.229 6.229 0 0 1-1.7-4.27c0-3.44 2.8-6.24 6.24-6.24 3.44 0 6.24 2.8 6.24 6.24 0 1.59-.6 3.11-1.7 4.27a.763.763 0 0 1-1.06.03z",
    fillRule: "nonzero"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.57 22.75c-1.14 0-2.15-.64-2.64-1.66-.49-1.02-.36-2.21.35-3.1l1.44-1.79c.56-.7 1.39-1.1 2.29-1.1.9 0 1.73.4 2.29 1.1l1.44 1.79c.71.89.85 2.08.35 3.1-.51 1.02-1.52 1.66-2.65 1.66h-2.87zm-1.13-3.83a1.39 1.39 0 0 0-.17 1.51c.24.51.73.81 1.29.81h2.87c.56 0 1.05-.3 1.29-.81s.18-1.07-.17-1.51l-1.44-1.79c-.54-.68-1.68-.68-2.23 0l-1.44 1.79z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVuesaxOutlineAirdrop);
export default __webpack_public_path__ + "static/media/vuesax-outline-airdrop.38ae9e6d8abe8e23a52d77a2b913f8bf.svg";
export { ForwardRef as ReactComponent };